import { atomWithKey as atom } from "./atomWithKey";
import dayjs, { Dayjs } from "dayjs";
import { SearchStateType } from "../Types/Index";
import { IFaqCategory } from "../Types/Interface/INeedHelp";
import { ICookiePreferences } from "../Types/Interface/ICookiePreferences";
import { IContactCategoryConfigResponse } from "../Types/Interface/ICustomerContact";
import { ICmsServiceClassFeatureList } from "../Types/Interface/ICmsServiceClassFeatureList";
import { ICmsProductFeatureList } from "../Types/Interface/ICmsProductFeatureList";

export type SliderData = {
  id: number;
  title: string;
  imageSrc: string;
  price?: string;
  fromTime?: string;
  toTime?: string;
};

export const sliderDataState = atom<SliderData[]>({
  key: "sliderDataState",
  default: [
    {
      id: 1,
      title: "Abu Dhabi - Dubai",
      imageSrc: "/images/SliderImage1.jpg",
      price: "AED 25",
      fromTime: "08:00",
      toTime: "09:30",
    },
    {
      id: 2,
      title: "Dubai - Sharjah",
      imageSrc: "/images/SliderImage1.jpg",
      price: "AED 20",
      fromTime: "09:00",
      toTime: "10:00",
    },
    {
      id: 3,
      title: "Abu Dhabi - Al Ain",
      imageSrc: "/images/SliderImage1.jpg",
      price: "AED 35",
      fromTime: "07:30",
      toTime: "09:00",
    },
    {
      id: 4,
      title: "Sharjah - Ajman",
      imageSrc: "/images/SliderImage1.jpg",
      price: "AED 15",
      fromTime: "10:00",
      toTime: "10:45",
    },
    {
      id: 5,
      title: "Dubai - Ras Al Khaimah",
      imageSrc: "/images/SliderImage1.jpg",
      price: "AED 40",
      fromTime: "11:00",
      toTime: "12:30",
    },
    {
      id: 6,
      title: "Ajman - Umm Al Quwain",
      imageSrc: "/images/SliderImage1.jpg",
      price: "AED 10",
      fromTime: "12:00",
      toTime: "12:30",
    },
    {
      id: 7,
      title: "Fujairah - Dubai",
      imageSrc: "/images/SliderImage1.jpg",
      price: "AED 45",
      fromTime: "13:00",
      toTime: "14:30",
    },
    {
      id: 8,
      title: "Ras Al Khaimah - Abu Dhabi",
      imageSrc: "/images/SliderImage1.jpg",
      price: "AED 50",
      fromTime: "14:00",
      toTime: "16:00",
    },
    {
      id: 9,
      title: "Sharjah - Dubai",
      imageSrc: "/images/SliderImage1.jpg",
      price: "AED 20",
      fromTime: "15:00",
      toTime: "15:45",
    },
  ],
});

export const sliderStationFacilitiesDataStateAtom = atom<SliderData[]>({
  key: "sliderStationFacilitiesDataStateAtom",
  default: [
    {
      id: 1,
      title: "CHECK-IN",
      imageSrc: "/assets/station_facilities/checkin.png",
    },
    {
      id: 2,
      title: "SEATING",
      imageSrc: "/assets/station_facilities/seating.png",
    },
    {
      id: 3,
      title: "STATION LOUNGE",
      imageSrc: "/assets/station_facilities/lounge.png",
    },
    {
      id: 4,
      title: "PARKING",
      imageSrc: "/assets/station_facilities/parking.png",
    },
    {
      id: 5,
      title: "CHECK-IN",
      imageSrc: "/assets/station_facilities/checkin.png",
    },
    {
      id: 6,
      title: "SEATING",
      imageSrc: "/assets/station_facilities/seating.png",
    },
    {
      id: 7,
      title: "STATION LOUNGE",
      imageSrc: "/assets/station_facilities/lounge.png",
    },
    {
      id: 8,
      title: "PARKING",
      imageSrc: "/assets/station_facilities/parking.png",
    },
    {
      id: 9,
      title: "CHECK-IN",
      imageSrc: "/assets/station_facilities/checkin.png",
    },
  ],
});

// Tracks whether Keycloak has been initialized
export const initializedStateAtom = atom<boolean>({
  key: "initializedStateAtom",
  default: false,
});

export const isAuthCheckCompleteStateAtom = atom<boolean>({
  key: "isAuthCheckCompleteStateAtom",
  default: false,
});

// Tracks authentication status
export const isAuthenticatedStateAtom = atom<boolean>({
  key: "isAuthenticatedStateAtom",
  default: false,
});

// Tracks if the session is anonymous
export const isAnonymousStateAtom = atom<boolean>({
  key: "isAnonymousStateAtom",
  default: true,
});

// Tracks if the booking is hyper fast
export const isHyperFastStateAtom = atom<boolean>({
  key: "isHyperFastStateAtom",
  default: false,
});

// Tracks if the booking is hyper fast
export const isQuickExchangeStateAtom = atom<boolean>({
  key: "isQuickExchangeStateAtom",
  default: false,
});

// Tracks if the booking is change date
export const isChangeDateStateAtom = atom<boolean>({
  key: "isChangeDateStateAtom",
  default: false,
});

// Tracks if the booking is Return Journey
export const isBookReturnJourneyAtom = atom<boolean>({
  key: "isBookReturnJourneyAtom",
  default: false,
});

// Tracks if the authentication state has been loaded
export const authLoadedStateAtom = atom<boolean>({
  key: "authLoadedStateAtom",
  default: false,
});

// Stores the access token
export const tokenStateAtom = atom<string | null>({
  key: "tokenStateAtom",
  default: null,
});

//stores config
export const configStateAtom = atom<any>({
  key: "configStateAtom",
  default: null,
});

export const outboundOfferIdAtom = atom<string | string[] | null>({
  key: "outboundOfferIdAtom",
  default: null,
});

export const inboundOfferIdAtom = atom<string | string[] | null>({
  key: "inboundOfferIdAtom",
  default: null,
});

inboundOfferIdAtom;

//user profile
export interface UserProfile {
  id: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
}

// Atom to store the user profile
export const userProfileStateAtom = atom<UserProfile | null>({
  key: "userProfileStateAtom",
  default: null,
});

export const carouselItemsState = atom({
  key: "carouselItemsState",
  default: [
    {
      id: 1,
      image: "/images/SliderImage2.jpg",
      offer: "AED 30",
      route: "Abu Dhabi - Dubai",
    },
    {
      id: 2,
      image: "/images/SliderImage1.jpg",
      offer: "AED 40",
      route: "Dubai - Sharjah",
    },
    {
      id: 3,
      image: "/images/SliderImage2.jpg",
      offer: "AED 40",
      route: "Abu Dhabi - Sharjah",
    },
  ],
});

export const searchStateAtom = atom<SearchStateType>({
  key: "searchStateAtom",
  default: {
    from: "",
    fromName: "",
    to: "",
    toName: "",
    calc: "",
    passengers: { adults: 1 },
    outboundDate: dayjs(),
    inboundDate: null,
    fromShuttle: false,
    toShuttle: false
  },
});

export const inboundSearchStateAtom = atom<SearchStateType>({
  key: "inboundSearchStateAtom",
  default: {
    from: "",
    fromName: "",
    to: "",
    toName: "",
    calc: "",
    passengers: {},
    outboundDate: dayjs(),
    inboundDate: null,
    fromShuttle: false,
    toShuttle: false
  },
});

//This atom is for storing backup data for Search Bar pop up in Offer Page
export const searchStatePopupAtom = atom<SearchStateType>({
  key: "searchStatePopupAtom",
  default: {
    from: "",
    fromName: "",
    to: "",
    toName: "",
    calc: "",
    passengers: {},
    outboundDate: dayjs(),
    inboundDate: null,
    oldSearch: null,
    fromShuttle: false,
    toShuttle: false
  },
});

export const selectedDateRangeStateAtom = atom<[Dayjs | null, Dayjs | null]>({
  key: "selectedDateRangeStateAtom",
  default: [null, null],
});

export const calendarDayIntervalAtom = atom<number | null>({
  key: "calendarDayIntervalAtom",
  default: 90,
});

export const selectedMenuAtom = atom<string>({
  key: "selectedMenuAtom",
  default: "",
});
export const getAppBanner = atom<boolean>({
  key: "getAppBanner",
  default: false,
});
export const selectOsInfo = atom<"iOS" | "Android" | "Other">({
  key: "selectOsInfo",
  default: "Other",
});
export const selectFaqAtom = atom<IFaqCategory[]>({
  key: "selectFaqAtom",
  default: [],
});
export const selectFaqLoading = atom<boolean>({
  key: "selectFaqLoading",
  default: true,
});

export const selectedRangeStateAtom = atom<[Dayjs | null, Dayjs | null]>({
  key: "selectedRangeStateAtom",
  // Default value for the selected date range
  default: [dayjs(), null],
});

export const cookieConsentGivenAtom = atom<boolean>({
  key: "cookieConsentGivenAtom",
  default: false,
});

export const cookieConsentBannerVisibleAtom = atom<boolean>({
  key: "cookieConsentBannerVisibleAtom",
  default: false,
});

export const cookieManagementModalVisibleAtom = atom<boolean>({
  key: "cookieManagementModalVisibleAtom",
  default: false,
});

export const cookiePreferencesAtom = atom<ICookiePreferences>({
  key: "cookiePreferencesAtom",
  default: {
    necessary: true,
    statistic: false,
    preferences: false,
    marketing: false,
  },
});

export const contactCategoriesAtom = atom<IContactCategoryConfigResponse>({
  key: "contactCategoriesAtom",
  default: {},
});

export const selectCorporateAccountFaqAtom = atom<IFaqCategory[]>({
  key: "selectCorporateAccountFaqAtom",
  default: [],
});
export const corporateAccountFlowStartedAtom = atom<boolean>({
  key: "corporateAccountFlowStartedAtom",
  default: false,
});
export const quickExchangeTripDirectionAtom = atom<string>({
  key: "quickExchangeTripDirectionAtom",
  default: "",
});

export const cmsServiceClassFeatureListAtom = atom<ICmsServiceClassFeatureList>({
  key: "cmsServiceClassFeatureListAtom",
  default: [],
});

export const cmsProductFeatureListAtom = atom<ICmsProductFeatureList>({
  key: "cmsProductFeatureListAtom",
  default: [],
});
